//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { createContext, type Dispatch, type SetStateAction } from 'react';
import {
  type QueryAnswerResponse, type SubmitQueryResponse
} from '@/services/apiTypes';

// -----------------------------------------------------------------------
// Query context value.
//
// Holds the query-editor state (question, query) and the query-execution
// methods.  submitQuery takes the target dataset as an argument (rather than
// reading it from the dataset slice) so this provider stays pure.
// -----------------------------------------------------------------------

export interface QueryContextValue {
  // --- State ---
  question: string;
  setQuestion: Dispatch<SetStateAction<string>>;
  query: string;
  setQuery: Dispatch<SetStateAction<string>>;

  // --- Methods ---
  submitQuery: (
    query: string, dataset_name: string
  ) => Promise<SubmitQueryResponse>;
  waitQuery: (
    jobId: string, offset: number, length: number
  ) => Promise<string>;
  getAnswer: (
    jobId: string, offset: number, length: number
  ) => Promise<QueryAnswerResponse>;
}

const QueryContext = createContext<QueryContextValue | null>(null);

export { QueryContext };
